<template>
    <div class="inner">
        <div class="xs-top clearfix">
            <div class="chart-con">
                <IconTitle :title="'全国规模上企业有R&D活动企业占比'" :iconName="'xinzengdaohangliebiao'"/>
                <div class="chart" id="chart1"></div>
            </div>
            <div class="chart-con">
                <IconTitle :title="'全国研究与开发机构数量'" :iconName="'jigoushuliang'"/>
                <div class="chart" id="chart2"></div>
            </div>
            <div class="chart-con">
                <IconTitle :title="'全国高等学校r&D人员数量(万人)'" :iconName="'zhishu'"/>
                <div class="chart" id="chart3"></div>
            </div>
            <div class="chart-con">
                <IconTitle :title="'各国研发支出占GPD比重'" :iconName="'gdpbizhong'"/>
                <div class="chart" id="chart4"></div>
            </div>
        </div>
        <div class="xs-bottom clearfix">
            <div class="xs-left fl">
                <div class="chart-con">
                    <IconTitle :title="'各省r&d人员数量'" class="lg" :iconName="'people'"/>
                    <div class="chart map" id="chart5"></div>
                </div>
            </div>
            <div class="xs-right fr">
                <div class="chart-con w-50 fl">
                    <IconTitle :title="'r&d经费占Gdp比重'" :iconName="'zuanshi'"/>
                    <div class="chart" id="chart6"></div>
                </div>
                <div class="chart-con w-50 fr">
                    <IconTitle :title="'r&d经费用途'" :iconName="'jingfeiyongtu'"/>
                    <div class="chart-con-list clearfix">
                        <div class="chart fl w-50" id="chart7"></div>
                        <div class="chart fr w-50" id="chart8"></div>
                    </div>
                </div>
                <div class="chart-con w-50 fl">
                    <IconTitle :title="'r&d经费资金来源占比'" :iconName="'jingfeibizhong'"/>
                    <div class="chart-map clearfix">
                        <div class="chart-info fl">
                            <div class="chart-info-list clearfix">
                                <span class="fl">
                                    <i></i>{{ ageParam.first_name }}
                                </span>
                                <span class="fr">
                                    <em>{{ firstTotal }}</em><br>(万元）
                                </span>
                            </div>
                            <div class="chart-info-list clearfix">
                                <span class="fl">
                                    <i></i>{{ ageParam.second_name }}
                                </span>
                                <span class="fr">
                                    <em>{{ secondTotal }}</em><br>(万元）
                                </span>
                            </div>
                        </div>
                        <div class="chart fr" id="chart9"></div>
                    </div>
                </div>
                <div class="chart-con w-50 fr">
                    <IconTitle :title="'有效专利数'" :iconName="'youxiaozhuanli'"/>
                    <div class="chart-con-list clearfix">
                        <div class="chart fl w-50" id="chart10"></div>
                        <div class="chart fr w-50" id="chart11"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IconTitle from '@/components/icontitle';
    import { kyBrokenLine, kyMap, kylinkAge } from "@/assets/scripts/api/xsdt";
    const LINE_COLOR = ['#05C0FB','#FB058F','#30CF70'];
    const EXPEND_COLOR = ['#FB058F','#EF9412','#30CF70','#05C0FB','#4256D4'];
    const PIE_COLOR = ['#344ED5', '#0179FF', '#01CDFF', '#30D070', '#FC058F'];
    const RADAR_COLOR = ['#FB058F','#05BDF7'];
    const LINE_COLOR1 = '#B6C8FF';
    const LINE_COLOR2 = '#3046C2';
    export default {
        name: 'GuoNeiKeYan',
        components: {
            IconTitle
        },
        data() {
            return {
                chinaData: [],
                ageParam: {
                    first_name: '上海',
                    second_name: '北京'
                },
                brokenArr:['上海','北京'],
                choseName:true,
                firstTotal: 0,
                secondTotal:0
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.getBrokenLine();
                this.getMap();
                this.getLinkAge();
            },
            initPieCharts(data,title) {
                let num = this.getNumber(data);

                const option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c} ({d}%)'
                    },
                    title: {
                        subtext: title +'(万元)',
                        subtextStyle: {
                            color: '#B5C8FF',
                            fontSize: 16,
                            fontWeight:'normal'
                        },
                        text: num ,
                        top: '42%',
                        textAlign: "center",
                        left: "48%",
                        textStyle: {
                            color: '#B5C8FF',
                            fontSize: 18,
                            fontWeight:'normal'
                        }
                    },
                    color: PIE_COLOR,
                    series: [
                        {
                            type: 'pie',
                            radius: ['60%', '90%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false
                            },
                            emphasis: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            data: data
                        }
                    ]
                };
                return option;
            },
            initRadarCharts(type,data) {
                const option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        show:false
                    },
                    grid: {
                        top: 'middle',
                        left: 0,
                        right: 0,
                        height: '70%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            textStyle: {
                                color: LINE_COLOR1,
                                fontSize: 14
                            }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: LINE_COLOR2
                            }
                        },
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: data.column
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: LINE_COLOR1,
                                fontSize: 14
                            }
                        },
                    },
                    series: {
                        type: 'line',
                        data: data.list,
                        color: LINE_COLOR[type],
                        lineStyle: {
                            normal: {
                                width: 2,
                                color: LINE_COLOR[type]
                            }
                        },
                        itemStyle: {
                            color: LINE_COLOR[type],
                            normal: {
                                color: LINE_COLOR[type],
                                borderWidth: 6,
                                borderColor: LINE_COLOR[type]
                            }
                        },
                        smooth: true
                    }
                };

                return option;
            },
            getBrokenLine() {
                kyBrokenLine().then((response) => {
                    let enterprise = response.data.enterprise,
                        expenditure = response.data.expenditure,
                        research = response.data.research,
                        school = response.data.school;


                    this.initChart1(enterprise);
                    this.initChart2(research);
                    this.initChart3(school);
                    this.initChart4(expenditure);
                })
            },
            getMap() {
                kyMap(this.ageParam).then((response) => {
                    let data = response.data;

                    data.forEach(item => {
                        let obj = {};
                        obj.value = item.person_count;
                        obj.name = item.name;
                        obj.checked = false;

                        if(this.ageParam.first_name == item.name || this.ageParam.second_name == item.name) {
                            obj.checked = true;
                        }
                        this.chinaData.push(obj);
                    })
                    this.initChart5();
                })
            },
            choiceCountry(name,item) {

                if(this.brokenArr.indexOf(name) > -1) {
                    item.checked = !item.checked;
                }
                if(this.brokenArr[0] != name && this.brokenArr[1] != name && this.choseName) {
                    this.brokenArr[0] = name;
                    this.choseName = false;
                }else if(this.brokenArr[0] != name && this.brokenArr[1] != name && !this.choseName) {
                    this.brokenArr[1] = name;
                    this.choseName = true;
                }
                this.ageParam.first_name = this.brokenArr[0];
                this.ageParam.second_name = this.brokenArr[1];

                this.getLinkAge();
            },
            getLinkAge() {
                kylinkAge(this.ageParam).then((response) => {
                    let expenditure = response.data.expenditure,
                        purpose = response.data.purpose,
                        patent = response.data.patent,
                        source = response.data.source,
                        num = response.data.num;

                    this.firstTotal = (num[0]/10000).toFixed(2);
                    this.secondTotal = (num[1]/10000).toFixed(2);
                    this.initChart6(expenditure);
                    this.initChart7(purpose[0]);
                    this.initChart8(purpose[1]);
                    this.initChart10(patent[0]);
                    this.initChart11(patent[1]);
                    this.initChart9(source);
                })
            },
            initChart1(data) {
                const chart = echarts.init(document.getElementById("chart1"));
                chart.setOption(this.initRadarCharts(0,data), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart2(data) {
                const chart = echarts.init(document.getElementById("chart2"));
                chart.setOption(this.initRadarCharts(1,data), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart3(data) {
                const chart = echarts.init(document.getElementById("chart3"));
                chart.setOption(this.initRadarCharts(2,data), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart4(expenditure) {
                let titleArr = expenditure.title,
                    list = expenditure.list,
                    legendData = [],
                    seriesData = [];

                titleArr.forEach((item,index) => {
                    let obj = {
                        name: item,
                        textStyle: {
                            color : EXPEND_COLOR[index]
                        }
                    };

                    legendData.push(obj);
                });

                list.forEach((item,index) =>{
                    let obj = {
                        name: titleArr[index],
                        type: 'line',
                        data: item,
                        color: EXPEND_COLOR[index],
                        lineStyle: {
                            normal: {
                                width: 2,
                                color: EXPEND_COLOR[index]
                            }
                        },
                        itemStyle: {
                            color: EXPEND_COLOR[index],
                            normal: {
                                color: EXPEND_COLOR[index],
                                borderWidth: 6,
                                borderColor: EXPEND_COLOR[index]
                            }
                        },
                        smooth: true
                    }
                    seriesData.push(obj);
                })
                const chart = echarts.init(document.getElementById("chart4"));
                const option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: legendData,
                        itemWidth: 6,
                        itemHeight: 6,
                        icon: 'circle',
                        left: 'center',
                        bottom: '3%'
                    },
                    grid: {
                        top: 'middle',
                        left: 0,
                        right: 0,
                        height: '70%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            textStyle: {
                                color: LINE_COLOR1,
                                fontSize: 14
                            }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: LINE_COLOR2
                            }
                        },
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: expenditure.column
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: LINE_COLOR1,
                                fontSize: 14
                            }
                        },
                    },
                    series: seriesData
                };

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart5() {
                const $that = this;
                const chart = echarts.init(document.getElementById("chart5"));
                const chartData = this.chinaData.sort((a,b)=>{
                    return a.value - b.value;
                });
                const option = {
                    tooltip: {
                        triggerOn: "mousemove",
                        formatter:function(params){
                            var a='<span>'+params.name+'</span>';
                            var b='<span>'+params.value+'</span>';
                            return [a,b].join(' :  ');
                        },
                        backgroundColor:'rgba(29, 38, 71)',
                    },
                    geo: {
                        show: true,
                        map: 'china',
                        zoom: 1,
                        label: {
                            emphasis: {
                                show: false
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderColor: '#090D28',
                                borderWidth: 1,
                                areaColor: '#8592FF',
                                shadowColor: 'rgba(133,146,255,.3)',
                                shadowBlur: 50
                            },
                            emphasis: {
                                areaColor: '#4E60F9'
                            }
                        }
                    },
                    visualMap: {
                        min: chartData[0].value,
                        max: chartData[chartData.length - 1].value,
                        left: 'left',
                        top: 'bottom',
                        text: ['高', '低'],
                        show: false,
                        calculable: false,
                        inRange: {
                            color: ['#8592FF', '#6978FF', '#4E60F9', '#384DDF', '#293FCA', '#1831B2']
                        }
                    },
                    series: [{
                        type: 'map',
                        geoIndex: 0,
                        data: chartData
                    }]
                };

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
                chart.on('click', function (params) {
                    $that.choiceCountry(params.name,params);
                });
            },
            getNumber(data) {
                let num =0;

                data.forEach(item => {
                    num += Number(item.value)
                })
                return num;
            },
            initChart6(expenditure) {
                let titleArr = expenditure.title,
                    list = expenditure.list,
                    legendData = [],
                    seriesData = [];

                titleArr.forEach((item,index) => {
                    let obj = {
                        name: item,
                        textStyle: {
                            color : LINE_COLOR[index]
                        }
                    };

                    legendData.push(obj);
                });

                list.forEach((item,index) =>{
                    let obj = {
                        name: titleArr[index],
                        type: 'line',
                        data: item,
                        color: LINE_COLOR[index],
                        lineStyle: {
                            normal: {
                                width: 2,
                                color: LINE_COLOR[index]
                            }
                        },
                        itemStyle: {
                            color: LINE_COLOR[index],
                            normal: {
                                color: LINE_COLOR[index],
                                borderWidth: 6,
                                borderColor: LINE_COLOR[index]
                            }
                        },
                        smooth: true
                    }
                    seriesData.push(obj);
                })
                const chart = echarts.init(document.getElementById("chart6"));
                const option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: legendData,
                        itemWidth: 6,
                        itemHeight: 6,
                        icon: 'circle',
                        left: 'center',
                        bottom: '6%'
                    },
                    grid: {
                        top: 'middle',
                        left: 0,
                        right: 0,
                        height: '60%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            textStyle: {
                                color: LINE_COLOR1,
                                fontSize: 14
                            }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: LINE_COLOR2
                            }
                        },
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: expenditure.column
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: LINE_COLOR1,
                                fontSize: 14
                            }
                        },
                    },
                    series: seriesData
                };

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart7(data){
                const chart = echarts.init(document.getElementById("chart7"));
                chart.setOption(this.initPieCharts(data,this.ageParam.first_name), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart8(data){
                const chart = echarts.init(document.getElementById("chart8"));
                chart.setOption(this.initPieCharts(data,this.ageParam.second_name), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart9(data){
                const indicator=[
                    {text: '政府资金'},
                    {text: '企业资金'},
                    {text: '国外资金'},
                    {text: '其他资金'}
                ]
                let seriesData = [];
                // let firstVal = data[0]['value'];
                //let secentVal = data[1]['value'];

                //this.firstTotal = data.num[0];
                // firstVal.forEach(item => {
                //     this.firstTotal += +item;
                // })
                // secentVal.forEach(item => {
                //     this.secondTotal += Number(item);
                // })

                data.forEach((item,index) => {

                    let obj = {
                        type: 'radar',
                        itemStyle: {
                            normal: {
                                color: RADAR_COLOR[index]
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: RADAR_COLOR[index],
                                opacity: 0.1
                            }
                        },
                        name:item.name,
                        data: [item.value]
                    }
                    seriesData.push(obj);
                })
                const chart = echarts.init(document.getElementById("chart9"));
                const option = {
                    grid: {
                        right:0
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    radar: {
                        center: ['50%','60%'],
                        radius: '45%',
                        splitArea: {
                            areaStyle: {
                                color: ['rgba(255, 255, 255, 0)', 'rgba(255, 255, 255, 0)', 'rgba(255, 255, 255, 0)', 'rgba(255, 255, 255, 0)']
                            }
                        },
                        nameGap:5,
                        splitLine: {
                            lineStyle: {
                                color: '#344DD5',
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#253694'
                            }
                        },
                        name: {
                            formatter: '{value}',
                            textStyle: {
                                color: '#B5C8FF'
                            },
                            fontSize: 14
                        },
                        indicator: indicator
                    },
                    series:seriesData
                };

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart10(data){
                const chart = echarts.init(document.getElementById("chart10"));
                chart.setOption(this.initPieCharts(data,this.ageParam.first_name), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart11(data){
                const chart = echarts.init(document.getElementById("chart11"));
                chart.setOption(this.initPieCharts(data,this.ageParam.second_name), true);
                chart.resize();
                this.$winResize(chart.resize);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/common.scss";
    .wrapper .inner{
        padding: 0 2.08%;
        .chart-con{
            height:100%;
            .chart{
                height:calc(100% - 0.4rem);
            }
        }
        .map {
            position: relative;
            background: url('~@/assets/images/mapbg.png') no-repeat 5px 42px / auto 18.8%;

            &:after {
                display: inline-block;
                content: '';
                width: 83.77%;
                height: 9.875%;
                background: url('~@/assets/images/mapline.png') no-repeat center center / 100% 100%;
                @include position(absolute, auto, auto, 5.49%, 50%);
                transform: translateX(-50%);
            }
        }
    }
    .xs-top{
        height:40%;
        .chart-con{
            float: left;
            width:24%;
            margin-right:1%;
            &:last-child{
                margin:0;
            }
        }
    }
    .xs-bottom{
        padding:1.5% 1.5% 0.8%;
        height:60%;
        background:#080B26;
        border:1px solid #233388;
        box-shadow:0px 0px 150px 0px rgba(39,58,159,0.5);
        .xs-left{
            width:49%;
            height:100%;
        }
        .xs-right{
            width:50%;
            height:100%;
            .w-50{
                width:49%;
                height:50%;
                .chart-con-list{
                    height: calc(100% - 0.4rem);
                    .chart{
                        height: 100%;
                    }
                }
                .chart-map{
                    height:calc(100% - 0.4rem);
                    .chart-info{
                        width:40%;
                        height:100%;
                        overflow: hidden;
                        .chart-info-list{
                            padding:0 2%;
                            height: 50%;
                            overflow: hidden;
                            background: url("~@/assets/images/xsdt/bg-t.png") no-repeat left bottom/contain;
                            span{
                                padding:35% 2% 0;
                                width:50%;
                                font-size:0.14rem;
                                color:#B5C8FF;
                                text-align: center;
                                i{
                                    display: block;
                                    height:0.08rem;
                                    margin:10% 0;
                                    background: url("~@/assets/images/xsdt/icon-2.png") no-repeat center bottom/contain;
                                }
                                em{
                                    font-size:0.24rem;
                                }
                            }
                            &:nth-child(2){
                                background: url("~@/assets/images/xsdt/bg-b.png") no-repeat left bottom/contain;
                                span{
                                    i{
                                        background: url("~@/assets/images/xsdt/icon-1.png") no-repeat center bottom/contain;
                                    }
                                }
                            }

                        }
                    }
                    .chart{
                        width:60%;
                        height:100%;
                    }
                }
            }
        }
    }
</style>